<template>
  <framed-layout>
    <terms-of-use/>

    <div class="flex items-center justify-center">
      <div class="px-4">
        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded my-3" @click="submitTermsOfUse(true)">
          Nõustun
        </button>
      </div>
      <div class="px-4">
        <button class="bg-red-500 hover:bg-red-700 font-bold py-2 px-4 rounded my-3" @click="submitTermsOfUse(false)">
          Ei nõustu
        </button>
      </div>
    </div>

  </framed-layout>
</template>

<script>
import FramedLayout from './../Layouts/FramedLayout'
import TermsOfUse from './../components/TermsOfUse'
import {acceptTerms} from "@/store/user.api";

export default {
  components: {
    FramedLayout,
    TermsOfUse
  },
  data() {
    return {
      projectId: null
    }
  },
  methods: {
    submitTermsOfUse: function (hasAccepted) {
      acceptTerms(hasAccepted).then(({data}) => {
        this.processAxiosPositiveResponse(data);
        var q = this.projectId === null ? null : {projectId: this.projectId};
        this.$router.push({
          path: '/email',
          query: q
        });
      })
    }
  },
  mounted() {
    this.projectId = this.$route.query?.projectId;
  }
}
</script>
